<template>
  <div class="terms-and-policy-layer">
    <div class="container">
      <p>We use our own cookies and cookies from 3rd parties to ensure that we give you the best experience on our website. If you continue, we’ll assume that you are happy to receive all cookies on the website. You can view our <a :href="cookiesLink" target="_blank">cookies policy</a> and <a :href="privacyLink" target="_blank">privacy policy</a> at any time.</p>
      <button class="close" @click="onClickClose"></button>
    </div>
  </div>
</template>

<script>
export default {
  dependencies: ['DATA'],
  computed: {
    cookiesLink() {
      return `https://www.musicalfreedom.com/uploads/${this.DATA.configs.footer.cookiesPolicy.filename}`
    },
    privacyLink() {
      return `https://www.musicalfreedom.com/uploads/${this.DATA.configs.footer.privacyPolicy.filename}`
    }
  },
  methods: {
    onClickClose(evt) {
      evt.preventDefault()
      this.$storage.set('cookiesAnswered', 'true')
      this.$el.style.pointerEvents = 'none'
      TweenMax.to(this.$el, 0.5, { y: -10, delay: 0, opacity: 0, ease: Quint.easeInOut })
    }
  },
  mounted() {
    TweenMax.fromTo(this.$el, 1, { y: -10, delay: 1, opacity: 0}, { y: 0, opacity:1, ease: Quint.easeInOut })
  }
}
</script>

<style lang="scss">
@import '../scss/variables';
.terms-and-policy-layer {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  background: #fff;
  height: auto;
  top: 0px;
  left: 0px;
  z-index: 99999;

  div.container {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 1080px;
    padding: 2rem 2rem;
    line-height: 1.5;
    display: flex;
    align-items: flex-start;

    p {
      display: inline-block;
      float: left;
      font-size: 1rem;

      a {
        color: #000;
      }
    }

    @media screen and (max-width: 1080px) {
      flex-direction: column;
      width: 100%;
      box-sizing: border-box;
      align-items: flex-end;
      padding-top: 1rem;

      p {
        order: 2;
      }

      button {
        order: 1;
        margin-left: 0px;
        margin-bottom: 2rem;
      }
    }

    .close {
      cursor: pointer;
      border-color: transparent;
      outline: none;
      background-color: transparent;
      background-size: 80% 80%;
      background-image: url('/static/images/close.svg');
      background-repeat: no-repeat;
      background-position: 50% 50%;
      width: 25px;
      height: 25px;
      position: relative;
      top: 10px;
      right: 10px;
      transition: transform 0.3s $easeOutBack;
      display: inline-block;
      margin-left: 3rem;
      &:hover {
        transform: scale(1.1);
      }
      &:active {
        transform: scale(0.9);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TermsAndPolicy.vue